import { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

const StyledSection = getStyledWrapper("section");

interface BackToTopStyles {
    wrapper?: InjectableCss;
    backToTopButton?: ButtonPresentationProps;
}

export const styles: BackToTopStyles = {
    wrapper: {
        css: css`
            display: flex;
            justify-content: flex-end;
        `,
    },
    backToTopButton: {
        variant: "secondary",
        css: css`
            margin: 16px 0;
        `,
    },
};
const GAIABackToTop: FC = () => {
    const backToTopClickHandler = () => {
        if (window) {
            window.scrollTo(0, 0);
        }
    };

    return (
        <StyledSection {...styles.wrapper}>
            <Button onClick={backToTopClickHandler} {...styles.backToTopButton}>
                {translate("Back to Top")}
            </Button>
        </StyledSection>
    );
};

const widgetModule: WidgetModule = {
    component: GAIABackToTop,
    definition: {
        group: "Common",
        displayName: "Back To Top",
    },
};

export default widgetModule;
